import { Eye } from "lucide-react";

export const ViewOnlyBanner = ({ darkMode }) => (
  <div
    className={`flex items-center gap-2 px-4 py-2.5 rounded-xl mb-4 border ${
      darkMode
        ? "bg-amber-900/20 border-amber-700/40 text-amber-300"
        : "bg-amber-50 border-amber-200 text-amber-700"
    }`}
    data-testid="view-only-banner"
  >
    <Eye className="w-4 h-4 shrink-0" />
    <span className="text-sm font-medium">View Only — You have read-only access to this section</span>
  </div>
);
